export default "__VITE_ASSET__Cb8M5OC___"